import './FrontC.sass';
import moment from 'moment';
import { useArticles } from '../api';
import { useState } from 'react';

import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';
import Pagination from '../components/Pagination';
import getTimestamp from '../library/tools/getTimestamp';

import iconPDF from '../assets/common/pdf.svg';
import { Link } from 'react-router-dom';
import Meta from '../components/Meta';

const FrontD = (props) => {
	const { routeData } = props;
	const { route } = routeData;
	const [currentPage, setCurrentPage] = useState(1);
	const { articles, breadcrumbs, totalPage } = useArticles(routeData.guid, route, 10, currentPage, '');

	return (
		<div className='FrontD min-page-height'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='page-content frontD'>
					<div className='tab-content'>
						{articles.map((article) => {
							const { title, postTime, files, url, guid } = article;
							const timestamp = getTimestamp(postTime);
							const date = moment(timestamp).format('YYYY/MM/DD');

							if (url) {
								return (
									<a href={url} target='_blank' rel='noreferrer noopener' className='article' key={guid}>
										<div className='left'>
											<div className='title'>{title}</div>
											<div className='bot-flex'>
												<div className='date'>{date}</div>
											</div>
										</div>

										{files ? (
											<div className='right'>
												<div className='icon'>
													<img src={iconPDF} alt='PDF' />
												</div>
											</div>
										) : null}
									</a>
								);
							}

							return (
								<Link to={`${routeData.route}/${article.guid}`} className='article' key={article.guid}>
									<div className='left'>
										<div className='title'>{title}</div>
										<div className='bot-flex'>
											<div className='date'>{date}</div>
										</div>
									</div>

									{files ? (
										<div className='right'>
											<div className='icon'>
												<img src={iconPDF} alt='PDF' />
											</div>
										</div>
									) : null}
								</Link>
							);
						})}
					</div>
				</div>
			</div>
			<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPage={totalPage} />
		</div>
	);
};

export default FrontD;
